import * as THREE from 'three'
import { useThree } from '@react-three/fiber'
import { useState } from 'react';
import { ImMenu } from "react-icons/im";
import { BsArrowDownCircleFill } from "react-icons/bs";

export default function Navigation ({setTargetPosition,setShowVideoMesh,setLookAtTarget,setIsStudioVisible, setIsMixedRealityVisible,
                                    setIsBlockChainVisible,setIsArtefactVisible,
                                    setIsAnamnesisVisible,setIsPhygitalVisible, setIsSteleVisible}) {

    const handleClick = (x,y,z,cx,cy,cz) => {
        setTargetPosition(new THREE.Vector3(x,y,z));
        setLookAtTarget(new THREE.Vector3(cx,cy,cz))
    }

    const [isStudioMenuVisible, setIsStudioMenuVisible] = useState(false);
    const [isStudioMenuFocused, setIsStudioMenuFocused] = useState(false);
    const [isMixedMenuVisible, setIsMixedMenuVisible] = useState(false);
    const [isMixedMenuFocused, setIsMixedMenuFocused] = useState(false);
    const [isBlockchainMenuVisible, setIsBlockchainMenuVisible] = useState(false);
    const [isBlockchainMenuFocused, setIsBlockchainMenuFocused] = useState(false);
    const [isArtefactMenuVisible, setIsArtefactMenuVisible] = useState(false);
    const [isArtefactMenuFocused, setIsArtefactMenuFocused] = useState(false);
    const [isPhygitalMenuVisible, setIsPhygitalMenuVisible] = useState(false);
    const [isPhygitalMenuFocused, setIsPhygitalMenuFocused] = useState(false);
    const [isAnamnesisMenuVisible, setIsAnamnesisMenuVisible] = useState(false);
    const [isAnamnesisMenuFocused, setIsAnamnesisMenuFocused] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    function handlePart(name) {
        setIsSteleVisible(false);
        setShowVideoMesh(false);
        setIsStudioVisible(false);
        setIsStudioMenuVisible(false);
        setIsStudioMenuFocused(false);
        setIsMixedRealityVisible(false);
        setIsMixedMenuVisible(false);
        setIsMixedMenuFocused(false);
        setIsBlockChainVisible(false);
        setIsBlockchainMenuVisible(false);
        setIsBlockchainMenuFocused(false);
        setIsArtefactVisible(false);
        setIsArtefactMenuVisible(false);
        setIsArtefactMenuFocused(false);
        setIsPhygitalVisible(false);
        setIsPhygitalMenuVisible(false);
        setIsPhygitalMenuFocused(false);
        setIsAnamnesisVisible(false);
        setIsAnamnesisMenuVisible(false);
        setIsAnamnesisMenuFocused(false);

        if (name === "realite_mixte") {
            setIsMixedRealityVisible(true);
            setIsMixedMenuVisible(true);
            setIsMixedMenuFocused(true);
        } else if (name === "blockchain") {
            setIsBlockChainVisible(true);
            setIsBlockchainMenuVisible(true);
            setIsBlockchainMenuFocused(true);
        } else if (name === "artefact") {
            setIsArtefactVisible(true);
            setIsArtefactMenuVisible(true);
            setIsArtefactMenuFocused(true);
        } else if (name === "phygital") {
            setIsPhygitalVisible(true);
            setIsPhygitalMenuVisible(true);
            setIsPhygitalMenuFocused(true);
        } else if (name === "anamnesis") {
            setIsAnamnesisVisible(true);
            setIsAnamnesisMenuVisible(true);
            setIsAnamnesisMenuFocused(true);
        } else if (name === "studio") {
            setIsStudioVisible(true);
            setIsStudioMenuVisible(true);
            setIsStudioMenuFocused(true);
        } else if (name === "logo") {
            setShowVideoMesh(true);
        }

    }

    function handleClickMenu() {
        setIsOpen(true);
    }

    return (

        <>        
            <nav className="header_navigation">

                <a href="#" onClick={()=> {handleClick(0, 0.25, 3, 0 , 0.4, 4); handlePart("logo");}}><img src="./images/logo.png" className="logo"/></a>

                {/* Menu ordinateur */}
                <div className="container_menu_laptop">

                    {/************************* Le Studio ************************* */}
                    <div className="header_links_block"
                    onMouseEnter={() => setIsStudioMenuVisible(true)}
                         onMouseLeave={() => setIsStudioMenuVisible(false)}>

                        <a href="#" onClick={ () => { handleClick(7.5,0.4,7,7.5,0.4,12); handlePart("studio"); }}
                        className={isStudioMenuFocused ? "active-link" : ""}>Le Studio</a>

                        {isStudioMenuVisible && (
                            <div className="header_sublinks_block">
                                <a href="#" onClick={ () => { handleClick(10,0.5,7,10,0.5,12); handlePart("studio"); }}>Le Studio</a>
                                <a href="#" onClick={ () => { handleClick(5,0.5,7,5,0.5,12); handlePart("studio"); }}>Note d'intention</a>
                            </div>
                        )}
                    </div>

                    {/************************* Artefact ************************* */}
                    <div className="header_links_block">
                    <div onMouseEnter={() => setIsArtefactMenuVisible(true)}
                         onMouseLeave={() => setIsArtefactMenuVisible(false)}>

                        <a href="#" onClick={ () => { handleClick(2.5,0.4,7,2.5,0.4,12); handlePart("artefact"); }}
                        className={isArtefactMenuFocused ? "active-link" : ""}>Artéfact</a>

                        {isArtefactMenuVisible && (
                            <div className="header_sublinks_block">
                                <a href="#" onClick={ () => { handleClick(10,0.5,9,10,0.5,12); handlePart("artefact"); }}>Polyethylène</a>
                                <a href="#" onClick={ () => { handleClick(5,0.5,9,5,0.5,12); handlePart("artefact"); }}>Transparence</a>
                                <a href="#" onClick={ () => { handleClick(0,0.5,9,0,0.5,12); handlePart("artefact"); }}>Polarisation</a>
                                <a href="#" onClick={ () => { handleClick(-5,0.5,9,-5,0.5,12); handlePart("artefact"); }}>Installation</a>
                            </div>
                        )}
                    </div>
                    </div>
                
                    {/************************* Réalisme spéculatif ************************* */}
                    <div className="header_links_block">
                    <div onMouseEnter={() => setIsMixedMenuVisible(true)}
                         onMouseLeave={() => setIsMixedMenuVisible(false)}>

                        <a href="#" onClick={ () => { handleClick(-2.5,0.4,5,-2.5,0.4,12); handlePart("realite_mixte"); }}
                        className={isMixedMenuFocused ? "active-link" : ""}>Perception</a>

                        {isMixedMenuVisible && (
                            <div className="header_sublinks_block">
                                <a href="#" onClick={ () => { handleClick(10,0.5,11,10,0.5,12); handlePart("realite_mixte"); }}>Flux Génératif</a>
                                <a href="#" onClick={ () => { handleClick(5,0.5,11,5,0.5,12); handlePart("realite_mixte"); }}>Déclencheur Visuel</a>
                                <a href="#" onClick={ () => { handleClick(0,0.5,11,0,0.5,12); handlePart("realite_mixte"); }}>Paréidolie</a>
                                <a href="#" onClick={ () => { handleClick(-5,0.5,11,-5,0.5,12); handlePart("realite_mixte"); }}>Mouvement de base</a>
                                <a href="#" onClick={ () => { handleClick(-10,0.5,11,-10,0.5,12); handlePart("realite_mixte"); }}>Interactivité</a>
                                <a href="#" onClick={ () => { handleClick(-15,0.5,11,-15,0.5,12); handlePart("realite_mixte"); }}>Conditions initiales</a>
                            </div>
                        )}
                    </div>
                    </div>  

                    {/************************* Phygital ************************* */}
                    <div className="header_links_block">
                    <div onMouseEnter={() => setIsPhygitalMenuVisible(true)}
                         onMouseLeave={() => setIsPhygitalMenuVisible(false)}>

                        <a href="#" onClick={ () => { handleClick(-2.5,0.4,10,-2.5,0.4,16); handlePart("phygital"); }}
                        className={isPhygitalMenuFocused ? "active-link" : ""}>phygital</a>

                        {isPhygitalMenuVisible && (
                            <div className="header_sublinks_block">
                        <a href="#" onClick={ () => { handleClick(10,0.5,15,10,0.5,16); handlePart("phygital"); }}>Diffusion en direct</a>
                        <a href="#" onClick={ () => { handleClick(5,0.5,15,5,0.5,16); handlePart("phygital"); }}>Happening</a>
                        <a href="#" onClick={ () => { handleClick(0,0.5,15,0,0.5,16); handlePart("phygital"); }}>Exposition</a>
                        <a href="#" onClick={ () => { handleClick(-5,0.5,15,-5,0.5,16); handlePart("phygital"); }}>Concert</a>
                        <a href="#" onClick={ () => { handleClick(-10,0.5,15,-10,0.5,16); handlePart("phygital"); }}>Immersion</a>
                        <a href="#" onClick={ () => { handleClick(-15,0.5,15,-15,0.5,16); handlePart("phygital"); }}>Mapping</a>
                            </div>
                        )}
                    </div>
                    </div>
  
                    {/************************* Blockchaine ************************* */}
                    <div className="header_links_block">
                    <div onMouseEnter={() => setIsBlockchainMenuVisible(true)}
                         onMouseLeave={() => setIsBlockchainMenuVisible(false)}>

                        <a href="#" onClick={ () => { handleClick(5,0.4,12,5,0.4,14); handlePart("blockchain"); }}
                        className={isBlockchainMenuFocused ? "active-link" : ""}>Blockchain</a>

                        {isBlockchainMenuVisible && (
                            <div className="header_sublinks_block">
                                <a href="#" onClick={ () => { handleClick(10,0.5,13,10,0.5,14); handlePart("blockchain"); }}>Web3 / NFTs</a>
                                <a href="#" onClick={ () => { handleClick(5,0.5,13,5,0.5,14); handlePart("blockchain"); }}>Métaverse</a>
                                <a href="#" onClick={ () => { handleClick(0,0.5,13,0,0.5,14); handlePart("blockchain"); }}>Programmatique</a>
                            </div>
                        )}
                    </div>
                    </div>

                    {/************************* Anamnesis ************************* */}
                    <div className="header_links_block">
                    <div onMouseEnter={() => setIsAnamnesisMenuVisible(true)}
                         onMouseLeave={() => setIsAnamnesisMenuVisible(false)}>

                        <a href="#" onClick={ () => { handleClick(5,0.4,15,5,0.4,18); handlePart("anamnesis"); }}
                        className={isAnamnesisMenuFocused ? "active-link" : ""}>anamnèse</a>

                        {isAnamnesisMenuVisible && (
                            <div className="header_sublinks_block">
                                <a href="#" onClick={ () => { handleClick(10,0.5,17,10,0.5,18); handlePart("anamnesis"); }}>La trace d'un souvenir</a>
                                <a href="#" onClick={ () => { handleClick(5,0.5,17,5,0.5,18); handlePart("anamnesis"); }}>Vitrail</a>
                                <a href="#" onClick={ () => { handleClick(0,0.5,17,0,0.5,18); handlePart("anamnesis"); }}>Architecture</a>
                            </div>
                        )}
                    </div>
                    </div>

                </div>

                {/* Menu smartphone */}
                <ImMenu id='menu_icon' onClick={handleClickMenu}/>
                { isOpen && (

                    <div id="navigation-mobile">

                    {/************************* Le Studio ************************* */}
                    <div className="smartphone_menu_links">
                        <h2>Le Studio</h2>
                        <a href="#" onClick={ () => { handleClick(10,0.5,7,10,0.5,12); handlePart("studio");setIsOpen(false); }}>Le Studio</a>
                        <a href="#" onClick={ () => { handleClick(5,0.5,7,5,0.5,12); handlePart("studio");setIsOpen(false); }}>Note d'intention</a>
                    </div>

                    {/************************* Artefact ************************* */}
                    <div className="smartphone_menu_links">
                        <h2>Artéfact</h2>
                        <a href="#" onClick={ () => { handleClick(10,0.5,9,10,0.5,12); handlePart("artefact");setIsOpen(false); }}>Polyethylène</a>
                        <a href="#" onClick={ () => { handleClick(5,0.5,9,5,0.5,12); handlePart("artefact");setIsOpen(false); }}>Transparence</a>
                        <a href="#" onClick={ () => { handleClick(0,0.5,9,0,0.5,12); handlePart("artefact");setIsOpen(false); }}>Polarisation</a>
                        <a href="#" onClick={ () => { handleClick(-5,0.5,9,-5,0.5,12); handlePart("artefact");setIsOpen(false); }}>Installation</a>
                    </div>
                
                    {/************************* Réalisme spéculatif ************************* */}
                    <div className="smartphone_menu_links">
                        <h2>Perception </h2>
                        <a href="#" onClick={ () => { handleClick(10,0.5,11,10,0.5,12); handlePart("realite_mixte");setIsOpen(false); }}>Flux Génératif</a>
                        <a href="#" onClick={ () => { handleClick(5,0.5,11,5,0.5,12); handlePart("realite_mixte");setIsOpen(false); }}>Déclencheur Visuel</a>
                        <a href="#" onClick={ () => { handleClick(0,0.5,11,0,0.5,12); handlePart("realite_mixte");setIsOpen(false); }}>Paréidolie</a>
                        <a href="#" onClick={ () => { handleClick(-5,0.5,11,-5,0.5,12); handlePart("realite_mixte");setIsOpen(false); }}>Mouvement de base</a>
                        <a href="#" onClick={ () => { handleClick(-10,0.5,11,-10,0.5,12); handlePart("realite_mixte");setIsOpen(false); }}>Interactivité</a>
                        <a href="#" onClick={ () => { handleClick(-15,0.5,11,-15,0.5,12); handlePart("realite_mixte");setIsOpen(false); }}>Conditions initiales</a>
                    </div>
  
                    {/************************* Phygital ************************* */}
                    <div className="smartphone_menu_links">
                        <h2>phygital</h2>
                        <a href="#" onClick={ () => { handleClick(10,0.5,15,10,0.5,16); handlePart("phygital");setIsOpen(false); }}>Diffusion en direct</a>
                        <a href="#" onClick={ () => { handleClick(5,0.5,15,5,0.5,16); handlePart("phygital");setIsOpen(false); }}>Happening</a>
                        <a href="#" onClick={ () => { handleClick(0,0.5,15,0,0.5,16); handlePart("phygital");setIsOpen(false); }}>Exposition</a>
                        <a href="#" onClick={ () => { handleClick(-5,0.5,15,-5,0.5,16); handlePart("phygital");setIsOpen(false); }}>Concert</a>
                        <a href="#" onClick={ () => { handleClick(-10,0.5,15,-10,0.5,16); handlePart("phygital");setIsOpen(false); }}>Immersion</a>
                        <a href="#" onClick={ () => { handleClick(-15,0.5,15,-15,0.5,16); handlePart("phygital");setIsOpen(false); }}>Mapping</a>
                    </div>
                    
                    {/************************* Blockchaine ************************* */}
                    <div className="smartphone_menu_links">
                        <h2>Blockchain</h2>
                        <a href="#" onClick={ () => { handleClick(10,0.5,13,10,0.5,14); handlePart("blockchain");setIsOpen(false); }}>Web3 / NFTs</a>
                        <a href="#" onClick={ () => { handleClick(5,0.5,13,5,0.5,14); handlePart("blockchain");setIsOpen(false); }}>Métaverse</a>
                        <a href="#" onClick={ () => { handleClick(0,0.5,13,0,0.5,14); handlePart("blockchain");setIsOpen(false); }}>Programmatique</a>
                    </div>  

                    {/************************* Anamnesis ************************* */}
                    <div className="smartphone_menu_links">
                        <h2>anamnèse</h2>
                        <a href="#" onClick={ () => { handleClick(10,0.5,17,10,0.5,18); handlePart("anamnesis");setIsOpen(false); }}>La trace d'un souvenir</a>
                        <a href="#" onClick={ () => { handleClick(5,0.5,17,5,0.5,18); handlePart("anamnesis");setIsOpen(false); }}>Vitrail</a>
                        <a href="#" onClick={ () => { handleClick(0,0.5,17,0,0.5,18); handlePart("anamnesis");setIsOpen(false); }}>Architecture</a>
                    </div>
                </div> )}

            </nav>

            <div id="container_btn_contact">
                <a href="#contact">
                    <BsArrowDownCircleFill />
                </a>
            </div>
        </>
    )

}